import { useState, useEffect } from 'react';

const stages = [
  'Loading candle data...',
  'Computing indicators (EMA 12, EMA 26)...',
  'Evaluating entry/exit rules...',
  'Generating trade log...',
  'Calculating performance metrics...',
];

export default function BacktestRunningMock() {
  const [stage, setStage] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const stageInterval = setInterval(() => {
      setStage((s) => (s < stages.length - 1 ? s + 1 : s));
    }, 1800);
    const progressInterval = setInterval(() => {
      setProgress((p) => (p < 100 ? p + 1 : 100));
    }, 80);
    return () => {
      clearInterval(stageInterval);
      clearInterval(progressInterval);
    };
  }, []);

  return (
    <div className="platform-mock">
      <div className="platform-mock-header"><span className="dot" /> Running Backtest</div>
      <div className="platform-mock-body" style={{ textAlign: 'center', padding: '2rem 1.5rem' }}>
        <div style={{
          fontSize: '0.8125rem',
          fontWeight: 600,
          color: '#e5e7eb',
          marginBottom: '1rem',
        }}>
          BTCUSDT &middot; 1D &middot; EMA Cross
        </div>

        {/* Progress bar */}
        <div style={{
          width: '100%',
          height: 6,
          background: '#181825',
          borderRadius: 3,
          overflow: 'hidden',
          marginBottom: '0.75rem',
        }}>
          <div style={{
            width: `${progress}%`,
            height: '100%',
            background: 'linear-gradient(90deg, #9d4edd, #7c3aed)',
            borderRadius: 3,
            transition: 'width 0.08s linear',
          }} />
        </div>

        <div style={{
          fontSize: '0.6875rem',
          color: '#9ca3af',
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
          marginBottom: '0.375rem',
        }}>
          {stages[stage]}
        </div>

        <div style={{
          fontSize: '0.625rem',
          color: '#4b5563',
        }}>
          {progress}% &middot; 812 candles
        </div>
      </div>
      <div className="platform-mock-caption">The engine processes every candle, computing indicators and evaluating rules at each bar.</div>
    </div>
  );
}
